import {
  Alert,
  Box,
  Button,
  Modal,
  SpaceBetween,
} from '@cloudscape-design/components';
import PropTypes from 'prop-types';
import React from 'react';

import AddressDisplay from './addressDisplay';

export default function UnverifiedAddressModal({
  visible,
  address,
  onClose,
  onConfirm,
  errorMessage,
}) {
  return (
    <Modal
      onDismiss={onClose}
      visible={visible}
      header="Unable to Verify Address"
      footer={(
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button
              variant="primary"
              onClick={() => {
                onClose();
              }}
            >
              Close and Check Address
            </Button>
            <Button
              onClick={() => {
                onClose();
                onConfirm();
              }}
            >
              Use Unverified Address
            </Button>
          </SpaceBetween>
        </Box>
      )}
    >
      <SpaceBetween size="xs">
        <Alert
          type="error"
          header={errorMessage}
        />
        <Box variant="h5">
          This address could not be confirmed by Easypost.
          Are you sure you want to use this address?
        </Box>
        <AddressDisplay address={address} />
      </SpaceBetween>
    </Modal>
  );
}

UnverifiedAddressModal.propTypes = {
  address: PropTypes.shape({
    name: PropTypes.string,
    company: PropTypes.string,
    phone: PropTypes.string,
    street1: PropTypes.string,
    street2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string,
    country: PropTypes.string,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  errorMessage: PropTypes.string.isRequired,
  visible: PropTypes.bool.isRequired,
};
